export const INCIDENT_HELP_DOMAIN = "incident" as const;

export const INCIDENT_HELP_SCREENS = {
  form: "incident.form",
  list: "incident.list",
} as const;

export const INCIDENT_FORM_HELP_KEYS = {
  property: "incident.form.property",
  type: "incident.form.type",
  date: "incident.form.date",
  time: "incident.form.time",
  details: "incident.form.details",
  incidentLocation: "incident.form.incident_location",
  images: "incident.form.images",
  sendNotification: "incident.form.send_notification",
  includeGpsCoordinates: "incident.form.include_gps_coordinates",
  submit: "incident.form.submit",
} as const;

export const INCIDENT_LIST_HELP_KEYS = {
  search: "incident.list.search",
  filters: "incident.list.filters",
  new: "incident.list.new",
  rows: "incident.list.rows",
  row: "incident.list.row",
  rowActions: "incident.list.row_actions",
  actionTransfer: "incident.list.action_transfer",
  actionView: "incident.list.action_view",
  actionEdit: "incident.list.action_edit",
  actionDelete: "incident.list.action_delete",
} as const;

export const INCIDENT_HELP_TOURS = {
  listIntro: "incident.list.intro",
  formCreate: "incident.form.create",
} as const;
